// Épico PO1-2570 (decisão 5A): a proposta de API passa a carregar
// conectorKey / servico / protocolo. As três telas de cotação (Editar, Lote e
// Nova Manual) guardam isso na proposta e, ao escolher, em `propostaEscolhida`,
// para a coleta e a etiqueta usarem depois sem redigitar nada.
//
// A chave de agregação da re-simulação passa a ser `transportadora|servico`:
// "Correios PAC" e "Correios SEDEX" já vinham com nomes distintos, mas um mesmo
// nome com serviços diferentes (ex.: Melhor Envio) somava como se fosse um.

const semVazio = (v) => (v === null || v === undefined || v === "" ? null : String(v));

// Campos da API que viajam na proposta (sempre presentes, null quando não há).
export function camposConector(f) {
  return {
    conectorKey: semVazio(f && f.conectorKey),
    servico: semVazio(f && f.servico),
    protocolo: semVazio(f && f.protocolo),
  };
}

export function chaveProposta(f) {
  const servico = semVazio(f && f.servico);
  return `${(f && f.transportadora) || ""}|${servico || ""}`;
}

// PO1-3915: veículo que a tabela cotou. O consulta-frete devolve
// `idTipoVeiculo` + `tipoVeiculo` por proposta (a linha sem veículo recebe uma
// proposta por veículo da tabela). Só entra quando a proposta tem veículo,
// para não mudar o formato de quem já grava `propostaEscolhida` só com conector.
export function camposVeiculo(f) {
  const id = f && (f.idTipoVeiculo != null ? f.idTipoVeiculo : f.tipoVeiculoId);
  const out = {};
  if (id != null && id !== "") out.tipoVeiculoId = Number(id);
  const nome = semVazio(f && f.tipoVeiculo);
  if (nome) out.tipoVeiculo = nome;
  return out;
}

// { conectorKey, servico, protocolo } da proposta escolhida (+ tipoVeiculoId /
// tipoVeiculo quando a proposta de tabela cotou um veículo, PO1-3915), ou null
// quando a proposta não veio de conector nem tem veículo (tabela comum, spot).
export function propostaEscolhidaDe(proposta) {
  const c = camposConector(proposta);
  const v = camposVeiculo(proposta);
  const temVeiculo = Object.keys(v).length > 0;
  if (!c.conectorKey && !c.servico && !c.protocolo && !temVeiculo) return null;
  return Object.assign(c, v);
}

// A proposta `c` é a escolhida no form? Nome igual e, quando as duas têm
// serviço, serviço igual (duas propostas do mesmo nome com serviços diferentes
// não podem aparecer as duas como "Selecionada").
export function mesmaProposta(form, c) {
  if (!form || !c) return false;
  if ((form.transportadora || "") !== (c.transportadora || "")) return false;
  const escolhida = form.propostaEscolhida || null;
  const servicoForm = escolhida ? semVazio(escolhida.servico) : null;
  const servicoC = semVazio(c.servico);
  if (servicoForm && servicoC) return servicoForm === servicoC;
  return true;
}

// Agrega o retorno do consulta-frete (um `result` por veículo do mix) em
// propostas por transportadora|servico, somando o custo entre os veículos e
// ficando com o maior prazo. Mesma regra de antes, com o serviço na chave.
export function agregarPropostas(results) {
  const totals = {};
  const ordem = [];
  (Array.isArray(results) ? results : []).forEach(function (result) {
    if (!result) return;
    const fretes = Array.isArray(result.freteCalculado) ? result.freteCalculado : [];
    fretes.forEach(function (f) {
      if (!f || !f.transportadora) return;
      const key = chaveProposta(f);
      const valor = f.custoFrete != null ? Number(f.custoFrete) : 0;
      if (!totals[key]) {
        totals[key] = Object.assign(
          {
            transportadora: f.transportadora,
            idTransportadora: f.idTransportadora != null ? f.idTransportadora : null,
            valor: 0,
            prazo: f.prazo != null ? f.prazo : null,
            fonte: f.fonte != null ? f.fonte : null,
            modoCalculo: f.modoCalculo != null ? f.modoCalculo : null,
            // PO1-3915: veículo/capacidade da tabela (null quando não veio).
            idTipoVeiculo: null,
            tipoVeiculo: null,
            capacidadeKg: null,
            acimaCapacidade: false,
          },
          camposConector(f)
        );
        ordem.push(key);
      }
      const t = totals[key];
      if (t.fonte == null && f.fonte != null) t.fonte = f.fonte;
      if (t.modoCalculo == null && f.modoCalculo != null) t.modoCalculo = f.modoCalculo;
      if (t.protocolo == null && f.protocolo != null) t.protocolo = String(f.protocolo);
      if (t.idTipoVeiculo == null && f.idTipoVeiculo != null) t.idTipoVeiculo = f.idTipoVeiculo;
      if (t.tipoVeiculo == null && f.tipoVeiculo != null) t.tipoVeiculo = String(f.tipoVeiculo);
      if (t.capacidadeKg == null && f.capacidadeKg != null) t.capacidadeKg = f.capacidadeKg;
      // basta um veículo do mix acima da capacidade para a opção inteira estar.
      if (f.acimaCapacidade === true) t.acimaCapacidade = true;
      t.valor += valor;
      if (f.prazo != null) t.prazo = t.prazo != null ? Math.max(t.prazo, f.prazo) : f.prazo;
    });
  });
  return ordem.map(function (k) {
    return totals[k];
  });
}

export default agregarPropostas;
